import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'
import { setCmsConditionCodeOptions as setCmsConditionCodeOptionsAction } from '../store/options.actions'

import { OptionsService } from '../services/options.service'

export function* setCmsConditionCodeOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getCmsConditionCodeOptions])
    const { entity } = response
    if (entity && entity.length) {
      const options = entity
        .map((obj: any) => {
          return { id: obj.id, name: obj.careLevel ? obj.careLevel.concat(' - ', obj.name) : obj.name }
        })
        .sort((e1, e2) => e1.name.localeCompare(e2.name))
      yield put(setCmsConditionCodeOptionsAction(options))
    }
  } catch (e) {
    yield put(throwPcrException(`setCmsConditionCodeOptions() error: ${e}`))
  }
}

export function* setCmsConditionCodeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setCmsConditionCodeOptions)
}
